import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { GlobalActions } from '@/store'
import { buildTemplate, getPrompt } from './utils'

export const useField = () => {
  const dispatch = useDispatch()

  const name = useSelector(migrationProjectSelector.getProjectTitle)
  const colors = useSelector(migrationProjectSelector.getProjectColors)
  const nodes = useSelector(migrationProjectSelector.getNodesWithBlocks)

  const pagesTemplate = buildTemplate(nodes)
  const colorsTemplate = colors
    .map((color) => `- ${color.title}: ${color.hexCode}`)
    .join('\n')

  const prompt = getPrompt(name, colorsTemplate, pagesTemplate)

  const [value, setValue] = useState(prompt)

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value)
  }

  const onCopyPrompt = () => {
    dispatch(GlobalActions.copy({ value }))

    sendGtmEvent(GtmTriggerName.EXPORT_PROMPT_COPY)
  }

  const onReset = () => {
    setValue(prompt)
  }

  const showResetBtn = value !== prompt

  return {
    value,
    showResetBtn,
    onChange,
    onCopyPrompt,
    onReset,
  }
}
